/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable consistent-return */
import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import {
  Alarm,
  Check,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  Copy,
  Cross,
  CurrencyEuro,
  FacebookBw,
  ForwardStep,
  Link as LinkIcon,
  Linkedin,
  Mail,
  Send,
  Signal,
  User,
  World,
  XTwitter,
} from '@saleshandy/icons';
import { Accordion, Button, SkeletonLoading } from '@saleshandy/design-system';
import { Link } from 'react-router-dom';
import { parsePhoneNumber } from 'libphonenumber-js';
import type { IProps } from './tasker-modal-container';
import { SequenceStepType } from '../../../sequence/enums';
import {
  getCallOutcomeOptions,
  isCallTask,
  isLinkedInType,
  isWhatsappTask,
} from '../tasks-content/utils/helper';
import { stepBgColor } from '../../../sequence/helpers/step-types';
import { Priority } from '../../../../shared/components/priority';
import { getStepPriority } from '../../../sequence/helpers/sequence-step';
import {
  getButtonLabel,
  getFormattedPhoneType,
  getProspectDetails,
  getProspectEmailListFromAttributes,
  patchProspectAttributesPrimaryEmail,
  getTaskContentLabel,
  removeLinkedinPrefix,
} from './utils/helper';
import TruncatedTextWithTooltip from '../../../../shared/components/truncated-text-with-tooltip';
import Select from '../../../../shared/design-system/components/select';
import { getTaskStatusParams } from '../../utils/helper';
import { getSubjectStr } from '../../../sequence/components/sequence-single-content/components/sequence-single-step-variant-item/helper';
import { TaskAction, TaskStatusKey } from '../../utils/enums';
import { accessibleOnClick } from '../../../../shared/utils/accessible-on-click';
import {
  executeOnRequestStatus,
  getFormattedDateWithMoment,
  getIsRequestPending,
} from '../../../../shared/utils';
import { getStepType } from '../../../sequence/shared/modals/create-step-modal/utils/helper';
import toaster, { Theme } from '../../../../shared/toaster';
import GenericCustomOutcomeDropdown from '../../../settings/components/custom-outcomes/components/custom-outcome-dropdown';
import {
  getOptionFromOutcome,
  mapOutcomeToOption,
} from '../../../sequence/components/sequence-single-content/components/sequence-single-contacts/components/prospect-outcome-select/utils/helper';
import { getOutcomeIcon } from '../../../sequence/components/sequence-single-content/components/sequence-single-contacts/components/contact-list-content/components/helpers/step-filter-mapper';
import {
  OverlayPopover,
  OverlayTooltip,
  Placement,
  TriggerType,
} from '../../../../shared/design-system/components/overlay';
import Icon from '../../../../shared/design-system/components/atoms/icon/icon';
import { getEmailVerificationIcon } from '../../../../shared/functions/get-email-verification-icon';
import hasPermission from '../../../../shared/utils/access-control/has-permission';
import { Permissions } from '../../../../shared/utils/access-control/enums/permissions';
import { getIsDemoAccount } from '../../../../shared/utils/user-details';
import { formatNumberToKM } from '../../../sequence/helpers/helper';
import { StorageUtil } from '../../../../shared/utils/storage';
import { getStepIcon } from '../tasks-content/utils/step-icon';
import Attachment from '../../../../shared/components/attachment';
import {
  AttachmentType,
  AttachmentUploadStatus,
} from '../../../../shared/editor/types';
import TruncatedTextWithAutoTooltip from '../../../../shared/components/truncated-text-with-auto-tooltip';
import InlineMentionEditor from '../../../prospect/components/prospect-kanban/Inline-mention-editor';
import { RequestStatus } from '../../../../shared/enums/request-status';
import { visibility } from '../../../prospect/types';
import { sanitizeRichText } from '../../../../shared/utils/sanitize-rich-text';
import CallLogsOutboundDetailSections from '../../../dialer/components/call-logs/components/call-logs-missed-call-detail/call-logs-outbound-detail-sections';

import {
  setInitiatedCallFromTask,
  setSelectedCallbackProspect,
} from '../../../dialer/dialer-slice';
import { CallLog, DialerCallSourceEnum } from '../../../dialer/types/call-logs';
import TaskerCallModal from './tasker-call-modal';
import TaskerCallInsights from './tasker-call-insights/tasker-call-insights';
import { ContactType } from '../../../../shared/design-system/components/atoms/prospect-contact-field/types';
import AddToDncModal from '../../../dialer/components/call-logs/components/add-to-dnc-modal/add-to-dnc-modal';
import { isOngoingDialerCall } from '../../../../shared/components/dialer/constants';

const getTaskIcon = (type: SequenceStepType) =>
  getStepIcon({ type, width: 20, height: 20, module: 'tasker-modal' });

const TaskerModal: React.FC<IProps> = ({
  show,
  taskStatus,
  tasksCount,
  taskerData,
  paginationOptions,
  taskId,
  allOutcomes,
  getTaskerDataRequestStatus,
  getShareableTaskerDataRequestStatus,
  outcomeChangeRequestStatus,
  updateTaskNoteRequestStatus,
  taskActionRequestStatus,
  filters,
  onHide,
  getTaskerDataRequest,
  updateTasks,
  onOutcomeChange,
  resetTaskerState,
  resetTaskId,
  onRefresh,
  setShowGlobalRestrictionModal,
  getShareableTaskerDataRequest,
  resetShareableTaskerState,
  shareableTaskerData,
  shareableHashId,
  getUndoTasksRequestStatus,
  insertTaskIntoTaskerData,
  setUserInteractedRef,
  updatePrimaryNumberRequest,
  updatePrimaryNumberRequestStatus,
  resetUpdatePrimaryNumberState,
  changePrimaryEmailInProspectRequest,
  changePrimaryEmailInProspectRequestStatus,
  resetProspectPrimaryEmailChangeRequestStatus,
  getWhatsappLinkRequest,
  getWhatsappLinkRequestStatus,
  getWhatsappLinkResponse,
  resetGetWhatsappLinkState,
  sendUploadAttachmentRequest,
  sendDeleteAttachmentRequest,
  resetUploadAttachmentRequest,
  resetDeleteAttachmentRequest,
  uploadAttachmentRequestStatus,
  uploadAttachmentRequestError,
  uploadedAttachment,
  deleteAttachmentRequestStatus,
  deleteAttachmentRequestError,
  deletedAttachmentId,
  sendCreateProspectNoteRequest,
  sendUpdateProspectNoteRequest,
  createProspectNoteRequestStatus,
  createProspectNoteRequestMessage,
  createProspectNoteResponse,
  updateProspectNoteRequestStatus,
  updateProspectNoteRequestMessage,
  resetCreateProspectNotesListRequest,
  resetUpdateProspectNoteRequest,
  getSingleProspectDetailsResponse,
  isDialerFeatureEnabled,
  isAgencyUser,
  addPhoneNumberRequestStatus,
  sendAddPhoneNumberRequest,
  resetAddPhoneNumberRequest,
  myPhoneNumbersList,
  taskOpenProspectId,
  sendGetSingleProspectDetailsRequest,
  getSingleProspectDetailsRequestStatus,
}) => {
  const isDialerAvailable =
    isDialerFeatureEnabled &&
    !isAgencyUser &&
    hasPermission(Permissions.PHONE_CALL_WRITE);
  const isShareable = !!shareableHashId;
  // const emailList = getSingleProspectDetailsResponse?.prospectContactInfo?.filter(
  //   (info) => info.type === 'email',
  // );

  const dispatch = useDispatch();

  const currentCallManagementState = useSelector(
    (state: any) => state?.dialer?.currentCallManagementState,
  );
  const isOngoingCall = isOngoingDialerCall({
    callIsInprogress: currentCallManagementState?.callIsInprogress,
    callStatus: currentCallManagementState?.callStatus,
  });

  //! State
  const [callOutcome, setCallOutcome] = useState<{
    key: string;
    label: string;
  }>(null);
  const [taskerDataIndex, setTaskerDataIndex] = useState(0);
  const [currentData, setCurrentData] = useState(
    isShareable ? null : taskerData?.[0],
  );

  const emailList = currentData?.prospect?.prospectContactInfo?.filter(
    (info) => info.type === 'email',
  );

  const [currentPage, setCurrentPage] = useState(paginationOptions.pageNumber);

  const getInitialTaskNumber = (index = null): number => {
    if (currentPage > 1) {
      return paginationOptions.pageLimit * (currentPage - 1) + 1 + index;
    }

    return index + 1 || 1;
  };

  const [currentTaskNumber, setCurrentTaskNumber] = useState(
    isShareable ? 1 : getInitialTaskNumber(),
  );
  const [isSubjectCopied, setIsSubjectCopied] = useState(false);
  const [isContentCopied, setIsContentCopied] = useState(false);
  const [isLinkCopied, setIsLinkCopied] = useState(false);
  const [showPhoneList, setShowPhoneList] = useState(false);
  const phoneListRef = useRef<HTMLDivElement>(null);
  const hasUserInteractedRef = useRef(false);
  const [hasUserInteracted, setHasUserInteracted] = useState(false);
  const createdNoteIdRef = useRef<number | null>(null);

  // Track if call was initiated from this task module
  const callInitiatedFromTaskRef = useRef(false);

  // DNC modal state
  const [showDncModal, setShowDncModal] = useState(false);

  // Add state to track if task note was updated
  const [isTaskNoteUpdated, setIsTaskNoteUpdated] = useState<boolean>(false);

  // Add state to track outcome change payload for local updates
  const [outcomeChangePayload, setOutcomeChangePayload] = useState<{
    prospectId: number;
    outcomeId: number;
  } | null>(null);

  // Add state to track selected phone number
  const [selectedPhoneNumber, setSelectedPhoneNumber] = useState<string>('');
  const [pendingPhoneNumber, setPendingPhoneNumber] = useState<string>('');
  const [selectedPrimaryEmailId, setSelectedPrimaryEmailId] = useState<
    number | null
  >(null);
  const [pendingPrimaryEmailId, setPendingPrimaryEmailId] = useState<
    number | null
  >(null);

  // Note editor state
  const [taskEditorValue, setTaskEditorValue] = useState<string>('');
  const [taskVisibilityKey, setTaskVisibilityKey] = useState<string>(
    visibility.Public,
  );
  const [taskAttachments, setTaskAttachments] = useState<AttachmentType[]>([]);
  // Track if note was just created (to update button text immediately)
  const [hasNote, setHasNote] = useState<boolean>(false);

  const MENTION_ARRAY = [
    {
      key: '1',
      label: 'John Doe',
      tag: 'John Doe',
    },
    {
      key: '2',
      label: 'Mike Shake',
      tag: 'Mike Shake',
    },
    {
      key: '3',
      label: 'Tom Cruise',
      tag: 'Tom Cruise',
    },
  ];

  const replaceNbspWithSpaces = (str) => {
    if (!str) return str;
    return str?.replace(/(&nbsp;)+/g, (match) =>
      ' '?.repeat(match?.length / 6),
    );
  };

  //! Helper Functions
  const getTaskerDataIndex = (): number => {
    if (currentPage === 1) {
      return tasksCount - 1;
    }

    return paginationOptions.pageLimit - 1;
  };

  const decodeHtmlEntities = (html: string): string => {
    if (!html) return '';

    // Create a temporary DOM element to decode HTML entities
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;

    // Get text content which automatically decodes HTML entities
    return tempDiv.textContent || tempDiv.innerText || '';
  };

  const getTooltip = (text: string, exterClass?: string) => (
    <Tooltip id="popover-basic" className={`bs-tooltip-inner ${exterClass}`}>
      {text}
    </Tooltip>
  );
  const onContentCopy = (text, isSubject = false) => {
    // Convert HTML to plain text using DOMParser (no regex, no external packages)
    const parser = new DOMParser();
    const doc = parser?.parseFromString(text, 'text/html');

    // Handle line breaks by replacing <br> with newlines before extracting text
    const brElements = doc?.querySelectorAll('br');
    brElements?.forEach((br) => {
      br?.replaceWith('\n');
    });

    // Handle paragraphs by adding newlines after them
    const pElements = doc?.querySelectorAll('p');
    pElements?.forEach((p) => {
      if (p?.nextSibling) {
        p?.insertAdjacentText('afterend', '\n');
      }
    });

    const plainText = doc.body.textContent || doc.body.innerText || '';

    navigator.clipboard.writeText(plainText);

    if (isSubject) {
      setIsSubjectCopied(true);
      setTimeout(() => {
        setIsSubjectCopied(false);
      }, 2000);
    } else {
      setIsContentCopied(true);
      setTimeout(() => {
        setIsContentCopied(false);
      }, 2000);
    }
  };
  const resetState = () => {
    setTaskerDataIndex(0);
    setCurrentTaskNumber(1);
    setCurrentData(taskerData[0]);
    setCurrentPage(paginationOptions.pageNumber);
    setCallOutcome(null);
  };
  const closeModal = () => {
    resetState();
    onHide();
    window?.history?.pushState(
      null,
      '',
      window?.location?.pathname + window?.location?.search,
    );
    setHasUserInteracted(false);
    hasUserInteractedRef.current = false;
    callInitiatedFromTaskRef.current = false;
  };

  const handleOutcomeChange = (option) => {
    setCallOutcome(option);
    setHasUserInteracted(true);
    hasUserInteractedRef.current = true;
    onOutcomeChange(option);
  };

  const apiCall = (pageNumber = currentPage) => {
    getTaskerDataRequest({
      status: getTaskStatusParams(taskStatus),
      pageLimit: paginationOptions.pageLimit,
      pageNumber,
      ...filters,
    });
  };
  const openLink = (url: string) => window.open(url, '_blank');

  const getTaskContent = (): string => {
    const contentText =
      currentData?.taskPayload?.payload?.connectionNote ||
      currentData?.taskPayload?.payload?.message ||
      currentData?.taskPayload?.payload?.content;

    return contentText?.length ? currentData?.taskPayload?.payload : null;
  };
  const getTaskInstruction = (): string => currentData?.instruction || null;

  const renderAttachments = () => {
    const attachments = currentData?.taskAttachments;

    if (!attachments || attachments.length === 0) {
      return null;
    }

    return (
      <div className="task-attachments mt-3">
        <div className="d-flex flex-wrap gap-6">
          {attachments?.map((attachmentData) => (
            <Attachment
              key={attachmentData?.id}
              attachment={{
                attachmentId: attachmentData?.attachment?.id,
                file: {
                  name: attachmentData?.attachment?.name,
                  size: attachmentData?.attachment?.size,
                  type: attachmentData?.attachment?.mimeType,
                },
                attachmentSize: Number(attachmentData?.attachment?.size),
                status: AttachmentUploadStatus.Existing,
              }}
              showAttachmentDeleteButton={false}
            />
          ))}
        </div>
      </div>
    );
  };

  // Transform API attachment format to AttachmentType format
  const transformApiAttachmentToAttachmentType = (
    apiAttachment: any,
  ): AttachmentType => {
    const sizeNumber = apiAttachment?.size
      ? parseInt(String(apiAttachment.size), 10)
      : 0;

    return {
      attachmentId: apiAttachment?.id,
      status: AttachmentUploadStatus.Existing,
      file: {
        name: apiAttachment?.name || '',
        type: apiAttachment?.mimeType || '',
        size: sizeNumber,
      },
      attachmentSize: sizeNumber,
    };
  };

  // Transform API attachments array to AttachmentType array
  const transformApiAttachments = (apiAttachments: any[]): AttachmentType[] => {
    if (!apiAttachments || !Array.isArray(apiAttachments)) {
      return [];
    }
    return apiAttachments.map(transformApiAttachmentToAttachmentType);
  };

  // Handle note editor change
  const handleTaskEditorChange = (value: string) => {
    setTaskEditorValue(value);
  };

  // Handle visibility change
  const handleTaskVisibilityChange = (key: string) => {
    setTaskVisibilityKey(key);
  };

  // Handle attachments change
  const handleTaskAttachmentsChange = (attachments: AttachmentType[]) => {
    setTaskAttachments(attachments);
  };

  // Handle attachment status change
  const handleTaskAttachmentStatusChange = (
    updatedAttachment: AttachmentType,
  ) => {
    setTaskAttachments((prev) =>
      prev.map((attachment) =>
        attachment.attachmentIdentifier ===
        updatedAttachment.attachmentIdentifier
          ? {
              ...attachment,
              ...updatedAttachment,
              status:
                updatedAttachment.status ||
                AttachmentUploadStatus.UploadSuccess,
            }
          : attachment,
      ),
    );
  };

  // Handle note save
  const handleTaskNoteSave = () => {
    const noteResponse = isShareable
      ? shareableTaskerData?.noteResponse
      : currentData?.noteResponse;

    const editorValue = taskEditorValue || noteResponse?.content || '';
    const visibilityKey =
      taskVisibilityKey || noteResponse?.visibility || visibility.Public;

    if (!editorValue?.trim()) return;

    // Collect attachments
    const currentAttachmentIds = taskAttachments
      .map((attachment) => attachment?.attachmentId)
      .filter((id): id is number => id !== undefined && id !== null);

    const existingApiAttachments = noteResponse?.attachments || [];
    const existingAttachmentIds = existingApiAttachments
      .map((attachment) => attachment?.id)
      .filter((id): id is number => id !== undefined && id !== null);

    const attachmentIds =
      currentAttachmentIds.length > 0
        ? currentAttachmentIds
        : existingAttachmentIds;

    const noteId = createdNoteIdRef.current || noteResponse?.id;

    if (noteId) {
      // Update note
      sendUpdateProspectNoteRequest?.({
        noteId,
        content: editorValue,
        visibility: visibilityKey as visibility,
        attachmentIds: attachmentIds.length > 0 ? attachmentIds : undefined,
      });
    } else if (currentData?.prospect?.id) {
      // Create note
      sendCreateProspectNoteRequest?.({
        prospectId: currentData.prospect.id,
        taskId: currentData.id,
        content: editorValue,
        visibility: visibilityKey as visibility,
        attachmentIds: attachmentIds.length > 0 ? attachmentIds : undefined,
      });
    }
  };

  const handleUpdateTask = (tAction: TaskAction) => {
    setHasUserInteracted(true);
    hasUserInteractedRef.current = true;
    updateTasks(currentData?.id, tAction, currentData?.type, {
      taskPayloads: [getTaskContent()],
      instructions: [getTaskInstruction()],
      callOutcome,
    });
  };

  const sendLinkedinRequest = () => {
    setHasUserInteracted(true);
    hasUserInteractedRef.current = true;

    if (getIsDemoAccount()) {
      setShowGlobalRestrictionModal(currentData?.type);

      return null;
    }

    const prospectDetails = getProspectDetails(
      currentData?.prospect?.attributes,
    );

    if (!prospectDetails?.LinkedIn) {
      return toaster.error('LinkedIn profile not found', { theme: Theme.New });
    }

    return window.open(prospectDetails?.LinkedIn, '_blank');
  };

  const sendWhatsAppRequest = () => {
    setHasUserInteracted(true);
    hasUserInteractedRef.current = true;

    getWhatsappLinkRequest(currentData?.hashId);

    // const contentText =
    //   currentData?.taskPayload?.payload?.connectionNote ||
    //   currentData?.taskPayload?.payload?.message ||
    //   currentData?.taskPayload?.payload?.content ||
    //   '';

    if (getIsDemoAccount()) {
      setShowGlobalRestrictionModal(currentData?.type);

      return null;
    }

    // Use URL from updatePrimaryNumberResponse if available, otherwise fallback to currentData
    // const baseUrl =
    //   updatePrimaryNumberResponse || currentData?.prospect?.redirectUrl;

    // const redirectUrl = getWhatsappLinkResponse;

    // // if (!prospectDetails?.['Phone Number']) {
    // //   return toaster.error('Phone number not found', { theme: Theme.New });
    // // }

    // return window.open(redirectUrl, '_blank');
  };

  const renderWhatsAppButton = () => {
    if (!isWhatsappTask(currentData?.type)) {
      return null;
    }

    const hasPhoneNumber = getProspectDetails(
      currentData?.prospect?.attributes,
    )?.['Phone Number'];
    const messageLength = currentData?.taskPayload?.payload?.message?.length;
    const isMessageTooLong = messageLength > 1900;
    const isLoading = getIsRequestPending(getWhatsappLinkRequestStatus);

    const buttonProps = {
      className: 'ml-3',
      onClick: sendWhatsAppRequest,
      disabled: !hasPhoneNumber,
      isLoading,
    };

    if (!hasPhoneNumber) {
      return (
        <OverlayTooltip
          text="WhatsApp number is not available"
          placement={Placement.Top}
          className="open-whatsapp-btn"
        >
          <Button {...buttonProps}>Open WhatsApp</Button>
        </OverlayTooltip>
      );
    }

    if (isMessageTooLong) {
      return (
        <OverlayTooltip
          text="Message too long. Please copy it manually to paste fully in WhatsApp."
          placement={Placement.Top}
        >
          <Button {...buttonProps}>Open WhatsApp</Button>
        </OverlayTooltip>
      );
    }

    return <Button {...buttonProps}>Open WhatsApp</Button>;
  };

  const onNextPage = () => {
    setCurrentPage((prev) => prev + 1);
    setTaskerDataIndex(0);
    setCurrentTaskNumber(getInitialTaskNumber(0));
    resetTaskId();
    // Reset primary number API state when changing pages
    resetUpdatePrimaryNumberState();
    resetGetWhatsappLinkState();
    setPendingPhoneNumber('');
    apiCall(currentPage + 1);
  };
  const onPrevPage = () => {
    setCurrentPage((prev) => prev - 1);
    setTaskerDataIndex(getTaskerDataIndex());
    setCurrentTaskNumber(getInitialTaskNumber(getTaskerDataIndex()));
    resetTaskId();
    // Reset primary number API state when changing pages
    resetUpdatePrimaryNumberState();
    resetGetWhatsappLinkState();
    setPendingPhoneNumber('');
    apiCall(currentPage - 1);
  };

  const onNextTask = () => {
    if (currentTaskNumber >= tasksCount) {
      return;
    }

    if (taskerDataIndex === taskerData?.length - 1) {
      onNextPage();
      return;
    }

    setCurrentTaskNumber(getInitialTaskNumber(taskerDataIndex + 1));
    setTaskerDataIndex((prev) => prev + 1);
    setCurrentData(taskerData[taskerDataIndex + 1]);
  };

  const onPrevTask = () => {
    if (currentTaskNumber <= 1) {
      return;
    }

    if (taskerDataIndex === 0 && currentPage > 1) {
      onPrevPage();
      return;
    }

    setCurrentTaskNumber(getInitialTaskNumber(taskerDataIndex - 1));
    setTaskerDataIndex((prev) => prev - 1);
    setCurrentData(taskerData[taskerDataIndex - 1]);
  };

  const togglePhoneList = () => {
    setShowPhoneList((prev) => !prev);
  };

  const handlePhoneNumberChange = (phoneNumber: string) => {
    setPendingPhoneNumber(phoneNumber);

    const selectedPhoneNumberData = currentData?.prospect?.phoneNumbers?.find(
      (phone) => phone?.contactInfo === phoneNumber,
    );

    const selectedPhoneNumberId = selectedPhoneNumberData?.id;

    updatePrimaryNumberRequest(
      currentData?.prospect?.id,
      selectedPhoneNumberId,
    );
  };

  const handleCallProspect = () => {
    if (!selectedPhoneNumber) return;

    let callingCode = '';
    let localNumber = selectedPhoneNumber;

    try {
      const parsed = parsePhoneNumber(selectedPhoneNumber);
      if (parsed) {
        callingCode = parsed.countryCallingCode?.toString() || '';
        localNumber = parsed.nationalNumber?.toString() || selectedPhoneNumber;
      }
    } catch {
      // If parsing fails, use the full number without calling code
    }
    if (!callingCode) {
      callingCode = '1';
    }

    callInitiatedFromTaskRef.current = true;
    dispatch(
      setInitiatedCallFromTask({
        taskId: currentData?.id,
        allowedPhoneNumbers:
          currentData?.prospect?.phoneNumbers?.map(
            (phone) => phone?.contactInfo,
          ) || '',
      }),
    );

    const firstName =
      currentData?.prospect?.attributes?.find(
        (attr) => attr?.fieldRef?.label === 'First Name',
      )?.attributeValue || '';
    const lastName =
      currentData?.prospect?.attributes?.find(
        (attr) => attr?.fieldRef?.label === 'Last Name',
      )?.attributeValue || '';

    dispatch(
      setSelectedCallbackProspect([
        {
          callSource: DialerCallSourceEnum.Task,
          prospect: {
            id: currentData?.prospect?.id,
            firstName,
            lastName,
          },
          prospectPhone: {
            callingCode,
            number: localNumber,
            phoneNumber: localNumber,
          },
          prospectPhoneNumberList:
            currentData?.prospect?.phoneNumbers
              ?.map((phone) => {
                const contact = phone?.contactInfo;
                if (!contact) return null;
                try {
                  const parsed = parsePhoneNumber(contact, 'US');
                  return {
                    id: phone?.id,
                    phoneNumber: parsed.nationalNumber?.toString() || contact,
                    number: contact,
                    callingCode: parsed.countryCallingCode?.toString() || '1',
                  };
                } catch {
                  return {
                    id: phone?.id,
                    phoneNumber: contact,
                    number: contact,
                    callingCode: '1',
                  };
                }
              })
              ?.filter(Boolean) || [],
        } as CallLog,
      ]),
    );
  };

  const handlePrimaryEmailChange = (primaryEmailProspectInfoId: number) => {
    if (isShareable) {
      return;
    }
    setPendingPrimaryEmailId(primaryEmailProspectInfoId);
    changePrimaryEmailInProspectRequest({
      contactId: currentData?.prospect?.id,
      primaryEmailProspectInfoId,
    });
  };

  // Close phone list on outside click
  useEffect(() => {
    if (!showPhoneList) return;
    function handleClickOutside(event: MouseEvent) {
      const target = event.target as Node;

      const toggleButton = document.querySelector('.task-phone-number');
      const isToggleButton = toggleButton && toggleButton.contains(target);

      if (
        phoneListRef.current &&
        !phoneListRef.current.contains(target) &&
        !isToggleButton
      ) {
        setShowPhoneList(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showPhoneList]);

  // Refresh task details when a call initiated from this task module ends
  useEffect(() => {
    const handleCallEnded = () => {
      if (callInitiatedFromTaskRef.current) {
        callInitiatedFromTaskRef.current = false;
        apiCall();
      }
    };
    window.addEventListener('sh:call-ended', handleCallEnded);
    return () => {
      window.removeEventListener('sh:call-ended', handleCallEnded);
    };
  }, [currentPage, taskStatus, filters]);

  //! UseEffect
  useEffect(() => {
    if (isShareable) {
      getShareableTaskerDataRequest({ hashId: shareableHashId });
    } else {
      apiCall();
    }
  }, [shareableHashId]);

  useEffect(() => {
    if (show && currentData?.hashId) {
      const queryParams = new URLSearchParams(window?.location?.search);
      queryParams.set('taskId', currentData?.hashId);
      const newUrl = `${window?.location?.pathname}?${queryParams?.toString()}`;
      window?.history?.pushState(null, '', newUrl);
    }
  }, [currentData, show]);

  useEffect(() => {
    executeOnRequestStatus({
      status: outcomeChangeRequestStatus,
      onSuccess: () => {
        if (!isShareable && outcomeChangePayload) {
          // Update local tasker data instead of calling API
          const outcomeDetails = allOutcomes?.find(
            (outcome) => outcome.id === outcomeChangePayload.outcomeId,
          );

          if (outcomeDetails && currentData) {
            const updatedCurrentData = {
              ...currentData,
              sequenceProspectTask: {
                ...currentData.sequenceProspectTask,
                sequenceProspect: {
                  ...currentData.sequenceProspectTask?.sequenceProspect,
                  categoryId: outcomeChangePayload?.outcomeId,
                  category: {
                    name: outcomeDetails?.name,
                    sentiment: outcomeDetails?.sentiment,
                  },
                },
              },
            };
            setCurrentData(updatedCurrentData);
          }

          // Clear the payload after updating
          setOutcomeChangePayload(null);
        }
      },
    });
  }, [
    outcomeChangeRequestStatus,
    outcomeChangePayload,
    allOutcomes,
    currentData,
  ]);

  useEffect(() => {
    executeOnRequestStatus({
      status: updateTaskNoteRequestStatus,
      onSuccess: () => {
        if (!isShareable) {
          // Set flag to prevent modal from closing during task note update
          setIsTaskNoteUpdated(true);
          // Reset flag after a short delay
          setTimeout(() => {
            setIsTaskNoteUpdated(false);
          }, 1000);
        }
      },
    });
  }, [updateTaskNoteRequestStatus, isShareable]);

  useEffect(() => {
    if (getIsRequestPending(getTaskerDataRequestStatus) || isShareable) {
      return;
    }

    if (!tasksCount || tasksCount === 0) {
      closeModal();
      return;
    }

    // Check if current task still exists in taskerData
    const currentTaskExists = taskerData?.some(
      (task) => task.id === currentData?.id,
    );

    // Only close modal if current task was removed AND we're at the last task globally
    // AND we have a valid currentData.id (to avoid closing during data refresh)
    // AND we're not in the middle of a task note update
    if (
      !currentTaskExists &&
      currentData?.id &&
      currentTaskNumber >= tasksCount &&
      taskerData &&
      taskerData?.length > 0 && // Ensure we have fresh data
      !isTaskNoteUpdated // Don't close during task note updates
    ) {
      closeModal();
      return;
    }

    //* If last task get removed */
    if (
      taskerData?.length === taskerDataIndex &&
      tasksCount > currentTaskNumber &&
      taskerData?.length > 1
    ) {
      onNextPage();
      return;
    }

    //* If first task from > 1 page get removed */
    if (taskerData?.length === taskerDataIndex) {
      onPrevTask();
    }

    // Only update currentData if we have valid taskerData and index
    if (
      taskerData &&
      taskerData?.length > 0 &&
      taskerDataIndex < taskerData?.length
    ) {
      setCurrentData(taskerData[taskerDataIndex]);
    }
  }, [
    tasksCount,
    currentData?.id,
    currentTaskNumber,
    taskerData,
    taskerDataIndex,
    isTaskNoteUpdated, // Add isTaskNoteUpdated to dependencies
  ]);

  useEffect(() => {
    executeOnRequestStatus({
      status: getShareableTaskerDataRequestStatus,
      onSuccess: () => {
        if (
          shareableTaskerData &&
          Object.keys(shareableTaskerData)?.length > 0
        ) {
          setCurrentData(shareableTaskerData);
        } else {
          toaster.error("You don't have the permission to view the task", {
            theme: Theme.New,
          });
          closeModal();
        }
        resetShareableTaskerState();
      },
      onFailed: () => {
        closeModal();
      },
    });
  }, [getShareableTaskerDataRequestStatus]);

  useEffect(() => {
    executeOnRequestStatus({
      status: getTaskerDataRequestStatus,
      onSuccess: () => {
        if (taskId) {
          const index = taskerData?.findIndex((task) => task?.id === taskId);

          if (index === -1) {
            // Don't close modal immediately, try to refresh first
            onRefresh();
            return;
          }

          setTaskerDataIndex(index);
          setCurrentTaskNumber(getInitialTaskNumber(index));
          setCurrentData(taskerData[index]);
          return;
        }

        // Only update currentData if we have valid taskerData and index
        if (
          taskerData &&
          taskerData?.length > 0 &&
          taskerDataIndex < taskerData?.length
        ) {
          setCurrentData(taskerData[taskerDataIndex]);
        }

        return () => {
          resetTaskerState();
        };
      },
    });
  }, [getTaskerDataRequestStatus]);

  useEffect(() => {
    executeOnRequestStatus({
      status: createProspectNoteRequestStatus,
      onSuccess: () => {
        toaster.success(createProspectNoteRequestMessage, {
          theme: Theme.New,
        });
        if (createProspectNoteResponse?.id) {
          createdNoteIdRef.current = createProspectNoteResponse.id;
        }
        setHasNote(true);
        resetCreateProspectNotesListRequest();
      },
    });
  }, [
    createProspectNoteRequestStatus,
    createProspectNoteRequestMessage,
    createProspectNoteResponse,
    resetCreateProspectNotesListRequest,
  ]);

  useEffect(() => {
    executeOnRequestStatus({
      status: updateProspectNoteRequestStatus,
      onSuccess: () => {
        toaster.success(updateProspectNoteRequestMessage, {
          theme: Theme.New,
        });
        resetUpdateProspectNoteRequest();
      },
    });
  }, [
    updateProspectNoteRequestStatus,
    updateProspectNoteRequestMessage,
    resetUpdateProspectNoteRequest,
  ]);

  // Add useEffect to handle immediate task removal from modal when action is performed
  useEffect(() => {
    if (!show || isShareable) {
      return;
    }

    // Check if current task still exists in taskerData
    const currentTaskExists = taskerData?.some(
      (task) => task?.id === currentData?.id,
    );

    if (!currentTaskExists && currentData?.id && !isTaskNoteUpdated) {
      // Store the removed task data in localStorage for undo functionality
      const taskToStore = {
        ...currentData,
        taskerDataIndex,
        currentPage,
        currentTaskNumber,
      };
      StorageUtil.setItem('undoTaskerTask', JSON.stringify(taskToStore));

      // Current task was removed, need to move to next task or close modal
      if (!taskerData || taskerData?.length === 0) {
        // No more tasks on current page, check if this was the last task globally
        if (currentTaskNumber >= tasksCount) {
          // This was the last task globally, close modal
          closeModal();
          return;
        }
        // There are more tasks on other pages, try to fetch next page
        onNextPage();
        return;
      }

      // Find the next available task
      let nextIndex = taskerDataIndex;

      // If current index is out of bounds, start from beginning
      if (nextIndex >= taskerData?.length) {
        nextIndex = 0;
      }

      // If we're at the last task and it was removed, go to previous
      if (
        nextIndex === taskerData?.length - 1 &&
        taskerDataIndex >= taskerData?.length
      ) {
        nextIndex = Math?.max(0, taskerData?.length - 1);
      }

      // Set the next task as current
      if (taskerData[nextIndex]) {
        setCurrentData(taskerData[nextIndex]);
        setTaskerDataIndex(nextIndex);
        setCurrentTaskNumber(getInitialTaskNumber(nextIndex));
      } else {
        // No more tasks available, close modal
        closeModal();
      }
    }
  }, [
    taskerData,
    currentData?.id,
    show,
    isShareable,
    tasksCount,
    currentTaskNumber,
    isTaskNoteUpdated, // Add isTaskNoteUpdated to dependencies
  ]);

  // Add useEffect to handle undo success and add task back to modal
  useEffect(() => {
    executeOnRequestStatus({
      status: getUndoTasksRequestStatus,
      onSuccess: () => {
        const taskToUndo = JSON.parse(StorageUtil.getItem('undoTaskerTask'));

        if (taskToUndo) {
          // Add the task back to the tasker data at the original index
          insertTaskIntoTaskerData({
            task: taskToUndo,
            index: taskToUndo.taskerDataIndex,
          });

          // Set the current data back to the undone task
          setCurrentData(taskToUndo);
          setTaskerDataIndex(taskToUndo.taskerDataIndex);
          setCurrentTaskNumber(taskToUndo.currentTaskNumber);
          setCurrentPage(taskToUndo.currentPage);

          // Remove the task from localStorage
          StorageUtil.removeItem('undoTaskerTask');
        }
      },
    });
  }, [getUndoTasksRequestStatus]);

  // Whenever hasUserInteractedRef changes, sync to parent if setUserInteractedRef is provided
  useEffect(() => {
    if (setUserInteractedRef) {
      setUserInteractedRef.current = hasUserInteractedRef.current;
    }
  }, [hasUserInteractedRef.current, setUserInteractedRef]);

  // Handle task action request success
  useEffect(() => {
    executeOnRequestStatus({
      status: taskActionRequestStatus,
      onSuccess: () => {
        setCallOutcome(null);
        if (isShareable) {
          closeModal();
        }
      },
    });
  }, [taskActionRequestStatus, isShareable]);

  useEffect(() => {
    executeOnRequestStatus({
      status: updatePrimaryNumberRequestStatus,
      onSuccess: () => {
        if (pendingPhoneNumber) {
          setSelectedPhoneNumber(pendingPhoneNumber);
          setPendingPhoneNumber('');

          // Update currentData with new primary phone number data
          if (currentData?.prospect?.phoneNumbers) {
            const updatedCurrentData = {
              ...currentData,
              prospect: {
                ...currentData.prospect,
                primaryPhoneProspectContactInfoId: currentData.prospect.phoneNumbers?.find(
                  (phone) => phone.contactInfo === pendingPhoneNumber,
                )?.id,
              },
            };
            setCurrentData(updatedCurrentData);
          }

          toaster.success('Primary number updated successfully', {
            theme: Theme.New,
          });
          resetUpdatePrimaryNumberState();
          setShowPhoneList(false);
        }
      },
    });
  }, [updatePrimaryNumberRequestStatus, pendingPhoneNumber, currentData]);

  useEffect(() => {
    executeOnRequestStatus({
      status: changePrimaryEmailInProspectRequestStatus,
      onSuccess: () => {
        if (pendingPrimaryEmailId != null && currentData?.prospect) {
          setSelectedPrimaryEmailId(pendingPrimaryEmailId);
          const updatedCurrentData = {
            ...currentData,
            prospect: {
              ...currentData.prospect,
              primaryEmailProspectContactInfoId: pendingPrimaryEmailId,
              attributes: patchProspectAttributesPrimaryEmail(
                currentData.prospect.attributes,
                pendingPrimaryEmailId,
              ),
            },
          };
          setCurrentData(updatedCurrentData);
          toaster.success('Primary email updated successfully', {
            theme: Theme.New,
          });
          resetProspectPrimaryEmailChangeRequestStatus();
          setPendingPrimaryEmailId(null);
        }
      },
      onFailed: () => {
        if (pendingPrimaryEmailId != null) {
          resetProspectPrimaryEmailChangeRequestStatus();
          setPendingPrimaryEmailId(null);
        }
      },
    });
  }, [
    changePrimaryEmailInProspectRequestStatus,
    pendingPrimaryEmailId,
    currentData,
  ]);

  useEffect(() => {
    executeOnRequestStatus({
      status: getWhatsappLinkRequestStatus,
      onSuccess: () => {
        const decodedWhatsappLinkResponse = replaceNbspWithSpaces(
          decodeURIComponent(getWhatsappLinkResponse),
        );
        // const contentText =
        //   currentData?.taskPayload?.payload?.connectionNote ||
        //   currentData?.taskPayload?.payload?.message ||
        //   currentData?.taskPayload?.payload?.content ||
        //   '';

        // // Strip HTML tags from contentText for WhatsApp
        // const plainTextContent = contentText.replace(/<\/?[a-zA-Z][^>]*>/g, '');

        // const redirectUrl = `${getWhatsappLinkResponse}&text=${encodeURIComponent(
        //   plainTextContent,
        // )}`;
        // if (redirectUrl) {
        window?.open(decodedWhatsappLinkResponse, '_blank');
        // }

        resetGetWhatsappLinkState();
      },
    });
  }, [getWhatsappLinkRequestStatus, getWhatsappLinkResponse]);

  useEffect(() => {
    executeOnRequestStatus({
      status: addPhoneNumberRequestStatus,
      onSuccess: () => {
        toaster.success('Phone number added to DNC list successfully');
        setShowDncModal(false);
        resetAddPhoneNumberRequest();
      },
    });
  }, [addPhoneNumberRequestStatus]);

  // Initialize selected phone number with primary contact
  useEffect(() => {
    const phoneNumbers = currentData?.prospect?.phoneNumbers;

    if (phoneNumbers?.length > 0) {
      const primaryPhoneNumberId =
        currentData?.prospect?.primaryPhoneProspectContactInfoId;
      const primaryPhoneNumber = phoneNumbers?.find(
        (phone) => phone?.id === primaryPhoneNumberId,
      );

      if (primaryPhoneNumber?.contactInfo) {
        setSelectedPhoneNumber(primaryPhoneNumber.contactInfo);
      } else {
        // Fallback to first phone number if no primary is set
        setSelectedPhoneNumber(phoneNumbers[0]?.contactInfo || '');
      }
    } else {
      // Clear phone number when current task has no phone numbers
      setSelectedPhoneNumber('');
    }
  }, [currentData]);

  useEffect(() => {
    const prospect = currentData?.prospect;
    const emails = getProspectEmailListFromAttributes(prospect?.attributes);
    const primaryId = prospect?.primaryEmailProspectContactInfoId;
    const detailEmails =
      getSingleProspectDetailsResponse?.prospectContactInfo?.filter(
        (info) => info.type === 'email',
      ) || [];
    const primaryMatchesDetailRow = detailEmails.some(
      (row) =>
        primaryId != null &&
        (row.contactInfoId === primaryId ||
          row.id === primaryId ||
          (row.contactInfoId ?? row.id) === primaryId),
    );
    if (
      primaryId &&
      (emails.some((e) => e.id === primaryId) || primaryMatchesDetailRow)
    ) {
      setSelectedPrimaryEmailId(primaryId);
    } else if (emails[0]?.id != null) {
      setSelectedPrimaryEmailId(emails[0].id);
    } else {
      setSelectedPrimaryEmailId(null);
    }
  }, [currentData, getSingleProspectDetailsResponse]);

  // Initialize note editor state from shareableTaskerData or currentData
  useEffect(() => {
    const noteResponse = isShareable
      ? shareableTaskerData?.noteResponse
      : currentData?.noteResponse;

    createdNoteIdRef.current = null;

    if (noteResponse) {
      // Initialize editor value from noteResponse
      setTaskEditorValue(noteResponse.content || '');

      // Initialize visibility key
      setTaskVisibilityKey(noteResponse.visibility || visibility.Public);

      // Initialize attachments
      if (noteResponse.attachments && noteResponse.attachments.length > 0) {
        setTaskAttachments(transformApiAttachments(noteResponse.attachments));
      } else {
        setTaskAttachments([]);
      }
      // Set hasNote to true if noteResponse exists
      setHasNote(true);
    } else {
      // Reset to defaults when no note exists
      setTaskEditorValue('');
      setTaskVisibilityKey(visibility.Public);
      setTaskAttachments([]);
      // Reset hasNote when no note exists
      setHasNote(false);
    }
  }, [currentData?.id, shareableTaskerData, isShareable]);

  const isLoading =
    getIsRequestPending(getTaskerDataRequestStatus) ||
    (isShareable && getIsRequestPending(getShareableTaskerDataRequestStatus)) ||
    getIsRequestPending(getSingleProspectDetailsRequestStatus);

  // Check if task is disabled (skipped or completed)
  const isTaskDisabled =
    taskStatus === TaskStatusKey.Skipped ||
    taskStatus === TaskStatusKey.Completed;

  // Note editor derived values
  const noteResponse = isShareable
    ? shareableTaskerData?.noteResponse
    : currentData?.noteResponse;
  const noteVisibility =
    noteResponse?.visibility || taskVisibilityKey || visibility.Public;
  const noteAttachments = (() => {
    if (taskAttachments.length > 0) {
      return taskAttachments;
    }
    if (noteResponse?.attachments) {
      return transformApiAttachments(noteResponse.attachments);
    }
    return [];
  })();

  //! Render Functions
  const renderTaskIcon = () => (
    <div
      style={{
        backgroundColor: stepBgColor[getStepType(currentData?.type)],
        width: '40px',
        height: '40px',
        borderRadius: '4px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {getTaskIcon(currentData?.type)}
    </div>
  );
  const renderTaskerPagination = () => {
    if (isShareable) {
      return null;
    }
    return (
      <div className="tasker-pagination-wrapper d-flex justify-content-between">
        <ChevronLeft
          width={20}
          height={20}
          className={`left-right-pagination-icon ${
            currentTaskNumber <= 1 || isShareable
              ? 'cursor-not-allowed opacity-30'
              : 'pointer'
          }`}
          onClick={!isShareable ? onPrevTask : () => {}}
        />
        <span className="regular-2 font-medium gray-txt-15">
          {currentTaskNumber} of{' '}
          {isShareable ? 1 : formatNumberToKM(tasksCount)} Tasks
        </span>
        <ChevronRight
          width={20}
          height={20}
          className={`left-right-pagination-icon ${
            isShareable || currentTaskNumber >= tasksCount
              ? 'cursor-not-allowed opacity-30'
              : 'pointer'
          }`}
          onClick={!isShareable ? onNextTask : () => {}}
        />
      </div>
    );
  };
  const renderTaskPriority = () => {
    const { text, variant, className } = getStepPriority(currentData?.priority);

    return <Priority text={text} variant={variant} className={className} />;
  };
  const renderProspectDetails = () => {
    const prospectDetails = getProspectDetails(
      currentData?.prospect?.attributes,
    );

    const phoneNumber = currentData?.prospect?.prospectContactInfo?.filter(
      (info) => info.type === 'phone',
    );
    const phoneNumberList = phoneNumber?.map((p) => p.contactInfo);

    const primaryPhoneNumberId =
      currentData?.prospect?.primaryPhoneProspectContactInfoId;

    const primaryPhoneNumber = phoneNumber?.find(
      (phone) => phone?.id === primaryPhoneNumberId,
    );

    const primaryContactInfo = primaryPhoneNumber?.contactInfo;

    const prospectEmailList = getProspectEmailListFromAttributes(
      currentData?.prospect?.attributes,
    );
    const primaryEmailProspectId =
      currentData?.prospect?.primaryEmailProspectContactInfoId;

    const primaryEmailFromList = prospectEmailList.find(
      (e) => e.id === primaryEmailProspectId,
    );
    /** When id vs contactInfoId differ, attributes may still have isPrimary set by patch. */
    const primaryEmailFromListByPrimaryFlag = prospectEmailList.find(
      (e) => e.isPrimary,
    );
    /** prospectContactInfo rows use contactInfoId and/or id — must match stored primary id after switch. */
    const primaryEmailFromContactInfoRows = emailList?.find((row) => {
      if (primaryEmailProspectId == null) return false;
      const rowKey = row.contactInfoId ?? row.id;
      return (
        rowKey === primaryEmailProspectId ||
        row.id === primaryEmailProspectId ||
        row.contactInfoId === primaryEmailProspectId
      );
    });

    const primaryEmailText =
      primaryEmailFromList?.email ||
      primaryEmailFromListByPrimaryFlag?.email ||
      primaryEmailFromContactInfoRows?.contactInfo ||
      prospectEmailList[0]?.email ||
      (typeof prospectDetails.Email === 'string' ? prospectDetails.Email : '');
    const statusCheck = getEmailVerificationIcon(
      primaryEmailFromListByPrimaryFlag?.emailVerificationStatus ||
        primaryEmailFromContactInfoRows?.emailVerificationStatus ||
        currentData?.verificationStatus ||
        'skip',
    );
    const getVerificationIcon = () => (
      <Icon
        identifier={statusCheck?.identifier}
        className={statusCheck?.className}
      />
    );

    return (
      <div className="position-relative d-flex align-items-center">
        <div className="pl-4 pr-4 tasker-modal-prospect-details">
          <div className="d-flex align-items-center">
            {isLoading ? (
              <>
                <SkeletonLoading width={16} height={16} className="mr-2" />
                <SkeletonLoading width={150} height={16} className="mr-2" />
                <SkeletonLoading width={16} height={16} className="mr-2" />
                <SkeletonLoading width={16} height={16} className="mr-2" />
              </>
            ) : (
              <>
                {/* <User width={16} height={16} className="gray-txt-15" />
                <span className="regular-2 popover-arrow-color-txt line-height-20 ml-2">
                  <TruncatedTextWithTooltip
                    length={40}
                    string={prospectDetails.Name}
                    textClassName="cursor-text"
                  />
                </span>
                {prospectDetails.LinkedIn && (
                  <Linkedin
                    width={16}
                    height={16}
                    className="gray-txt-15 ml-2 pointer social-media-icon-linkedin"
                    onClick={() => openLink(prospectDetails.LinkedIn)}
                  />
                )}
                {prospectDetails.Twitter && (
                  <div className="x-twitter">
                    <XTwitter
                      width={16}
                      height={16}
                      className="ml-2 pointer"
                      onClick={() => openLink(prospectDetails.Twitter)}
                    />
                  </div>
                )}
                {prospectDetails.Facebook && (
                  <FacebookBw
                    width={16}
                    height={16}
                    className="gray-txt-15 ml-2 pointer social-media-icon-facebook-world mt-1"
                    onClick={() => openLink(prospectDetails.Facebook)}
                  />
                )}
                {prospectDetails.Website && (
                  <World
                    width={16}
                    height={16}
                    className="gray-txt-15 ml-2 pointer social-media-icon-facebook-world world"
                    onClick={() => openLink(prospectDetails.Website)}
                  />
                )} */}

                <TaskerCallModal
                  prospectId={taskOpenProspectId}
                  onDoNotContactClick={() => setShowDncModal(true)}
                  sendGetSingleProspectDetailsRequest={
                    sendGetSingleProspectDetailsRequest
                  }
                  currentData={currentData}
                />
              </>
            )}
          </div>

          {isLoading ? (
            <div className="d-flex align-items-center mt-2">
              <SkeletonLoading width={16} height={16} className="mr-2" />
              <SkeletonLoading width={200} height={16} />
            </div>
          ) : (
            primaryEmailText && (
              <div className="d-flex flex-column mt-1">
                <label htmlFor="primary-email-input" className="label-text">
                  Email
                </label>
                {/* <Mail width={16} height={16} className="gray-txt-15" /> */}
                <div className="d-flex align-items-center gap-4">
                  <OverlayTooltip text={statusCheck?.toolTipText}>
                    {getVerificationIcon()}
                  </OverlayTooltip>
                  <span className="regular-2 popover-arrow-color-txt line-height-20">
                    <TruncatedTextWithTooltip
                      length={40}
                      string={primaryEmailText}
                      textClassName="cursor-text"
                    />
                  </span>
                  {emailList?.length > 1 && (
                    <OverlayPopover
                      className="p-0 tasker-email-switch-popover"
                      content={
                        <div className="tasker-email-switch-popover-inner">
                          {emailList?.map((emailRow) => {
                            const vConfig =
                              getEmailVerificationIcon(
                                emailRow?.emailVerificationStatus || 'skip',
                              ) || getEmailVerificationIcon('skip');
                            /** Same id prospect + API use for primary email (contactInfoId and id can differ). */
                            const primaryEmailRowId =
                              emailRow?.contactInfoId ?? emailRow?.id;
                            const primaryEmailRowText =
                              emailRow?.contactInfo ?? emailRow?.email;
                            return (
                              <div
                                key={primaryEmailRowId}
                                className="d-flex justify-content-between align-items-center w-100 px-3 tasker-email-switch-row"
                              >
                                <div className="d-flex align-items-center gap-6">
                                  <OverlayTooltip
                                    text="Set as Primary Email"
                                    placement={Placement.Bottom}
                                  >
                                    <label
                                      className={`bs-radio-wrapper ${
                                        isShareable
                                          ? 'bs-radio-wrapper-disabled'
                                          : ''
                                      }`}
                                    >
                                      <span
                                        className={`bs-radio ${
                                          isShareable ? 'bs-radio-disabled' : ''
                                        } ${
                                          selectedPrimaryEmailId ===
                                          primaryEmailRowId
                                            ? 'bs-radio-checked'
                                            : ''
                                        }`}
                                      >
                                        <input
                                          type="radio"
                                          name={`tasker-primary-email-${currentData?.prospect?.id}`}
                                          value={String(primaryEmailRowId)}
                                          checked={
                                            primaryEmailText ===
                                            primaryEmailRowText
                                          }
                                          disabled={isShareable}
                                          onChange={() =>
                                            handlePrimaryEmailChange(
                                              primaryEmailRowId,
                                            )
                                          }
                                          className="bs-radio-input radio-button"
                                        />
                                        <span className="bs-radio-inner" />
                                      </span>
                                    </label>
                                  </OverlayTooltip>
                                  <span className="number-list">
                                    {getFormattedPhoneType(
                                      emailRow?.contactInfoCategory || 'other',
                                    )}
                                  </span>
                                </div>
                                <div className="d-flex align-items-center gap-4 min-width-0">
                                  <OverlayTooltip
                                    text={vConfig.toolTipText}
                                    placement={Placement.Bottom}
                                  >
                                    <Icon
                                      identifier={vConfig.identifier}
                                      className={vConfig.className}
                                    />
                                  </OverlayTooltip>
                                  <span className="number-list min-width-0">
                                    <TruncatedTextWithTooltip
                                      length={28}
                                      string={emailRow?.contactInfo}
                                      textClassName="cursor-text"
                                    />
                                  </span>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      }
                      placement={Placement.BottomStart}
                      trigger={TriggerType.Click}
                      rootClose
                    >
                      <span
                        className="task-email-more"
                        tabIndex={0}
                        role="button"
                      >
                        {` +${emailList?.length - 1} more`}
                      </span>
                    </OverlayPopover>
                  )}
                </div>
              </div>
            )
          )}

          {isLoading ? (
            <div className="d-flex align-items-center">
              <SkeletonLoading width={16} height={16} className="mr-2" />
              <SkeletonLoading width={120} height={16} />
            </div>
          ) : (
            phoneNumber?.length !== 0 &&
            (isCallTask(currentData?.type) ||
              isWhatsappTask(currentData?.type)) && (
              <div className="d-flex align-items-center">
                <div className="d-flex flex-column">
                  <label
                    htmlFor="primary-phone-number-input"
                    className="label-text"
                  >
                    Phone
                  </label>
                  <div className="d-flex align-items-center gap-4">
                    <span className="regular-2 popover-arrow-color-txt line-height-20">
                      {primaryContactInfo}
                    </span>
                    {phoneNumberList?.length > 1 && (
                      <span
                        className="task-phone-number"
                        {...accessibleOnClick(togglePhoneList)}
                      >
                        {phoneNumberList.length > 1 &&
                          ` +${phoneNumberList.length - 1} more`}
                      </span>
                    )}
                  </div>
                </div>
                {showPhoneList && (
                  <div className="phone-number-popover" ref={phoneListRef}>
                    {phoneNumber?.map((phone, index) => (
                      <div
                        // eslint-disable-next-line react/no-array-index-key
                        key={index}
                        className="d-flex justify-content-between align-items-center w-100 px-3 ptb-6"
                      >
                        <div className="d-flex align-items-center gap-6">
                          <OverlayTooltip
                            text="Set as Primary Number"
                            placement={Placement.Bottom}
                          >
                            <label className="bs-radio-wrapper">
                              <span
                                className={`bs-radio ${
                                  selectedPhoneNumber === phone?.contactInfo
                                    ? 'bs-radio-checked'
                                    : ''
                                }`}
                              >
                                <input
                                  type="radio"
                                  name="phoneNumber"
                                  value={phone?.contactInfo}
                                  checked={
                                    selectedPhoneNumber === phone?.contactInfo
                                  }
                                  onChange={() =>
                                    handlePhoneNumberChange(phone?.contactInfo)
                                  }
                                  className="bs-radio-input radio-button"
                                />
                                <span className="bs-radio-inner" />
                              </span>
                            </label>
                          </OverlayTooltip>
                          <span className="number-list">
                            {getFormattedPhoneType(phone?.contactInfoCategory)}
                          </span>
                        </div>
                        <span className="number-list">
                          {phone?.contactInfo}
                        </span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )
          )}

          <div className="d-flex align-items-center">
            {isLoading ? (
              <>
                <SkeletonLoading width={16} height={16} className="mr-2" />
                <SkeletonLoading width={80} height={16} className="mr-2" />
                <SkeletonLoading width={200} height={16} />
              </>
            ) : (
              <div className="d-flex flex-column">
                <label htmlFor="sequence-name-input" className="label-text">
                  Source
                </label>
                <div>
                  <span className="sequence-step-num">
                    {currentData?.sequenceProspectTask?.step?.number &&
                      `Step ${currentData?.sequenceProspectTask?.step?.number}`}
                  </span>
                  {currentData?.sequenceProspectTask?.step?.number ? (
                    <Link
                      to={
                        currentData?.type === 'subsequence'
                          ? `/sequence/${currentData?.sequence?.parentSequenceId}/subsequence/${currentData?.sequence?.id}/steps`
                          : `/sequence/${currentData?.sequence?.id}/steps`
                      }
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-decoration-none"
                    >
                      <TruncatedTextWithTooltip
                        string={currentData?.sequence?.title}
                        length={40}
                        textClassName="sequence-name-tasker-modal ml-1"
                      />
                    </Link>
                  ) : (
                    <span className="regular-2 font-medium sequence-name-tasker-modal">
                      Manual Task
                    </span>
                  )}
                </div>
              </div>
            )}
          </div>

          {!isLoading && currentData?.sequenceProspectTask?.step?.number && (
            <div className="d-flex flex-column">
              <label htmlFor="prospect-outcome-select" className="label-text">
                Prospect outcome
              </label>
              <div>
                <GenericCustomOutcomeDropdown
                  showFooter={false}
                  options={mapOutcomeToOption(allOutcomes)}
                  showTotal={false}
                  className="prospect-outcome-select"
                  changeOutcomeRequestPayload={{
                    sequenceId:
                      currentData?.sequenceProspectTask?.step?.sequenceId,
                    prospectId: currentData?.prospect?.id,
                  }}
                  initialSelectedOption={getOptionFromOutcome(
                    allOutcomes,
                    currentData?.sequenceProspectTask?.sequenceProspect
                      ?.categoryId,
                  )}
                  optionRenderer={(option) => (
                    <div className="d-flex align-items-center">
                      {getOutcomeIcon(option?.name, false, {
                        isDefault: option.isDefault,
                        sentiment: option.sentiment,
                      })}
                      <span className="ml-1">{option.name}</span>
                    </div>
                  )}
                  disabled={!hasPermission(Permissions.UNIBOX_CATEGORY_UPDATE)}
                  onChange={(option) => {
                    if (option) {
                      setOutcomeChangePayload({
                        prospectId: currentData?.prospect?.id,
                        outcomeId: option.id,
                      });
                    }
                    setHasUserInteracted(true);
                    hasUserInteractedRef.current = true;
                  }}
                  delayUpdate={true}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };
  const renderTaskInstruction = () => (
    <>
      <div className="cs-accordion blue-17 task-instruction-container">
        <Accordion allowMultipleExpanded allowZeroExpanded preExpanded={['a']}>
          <Accordion.Item uuid="a">
            <Accordion.ItemHeading>
              <Accordion.ItemButton>
                <span className="semibold-1 gray-txt-15">Task Instruction</span>
                <Accordion.ItemState>
                  {({ expanded }) =>
                    expanded ? <ChevronUp /> : <ChevronDown />
                  }
                </Accordion.ItemState>
              </Accordion.ItemButton>
            </Accordion.ItemHeading>
            <Accordion.ItemPanel>
              <span className="regular-2 popover-arrow-color-txt">
                {decodeHtmlEntities(currentData?.instruction)}
              </span>
            </Accordion.ItemPanel>
          </Accordion.Item>
        </Accordion>
      </div>
    </>
  );
  const renderTaskContent = () => {
    const contentText =
      currentData?.taskPayload?.payload?.connectionNote ||
      currentData?.taskPayload?.payload?.message ||
      currentData?.taskPayload?.payload?.content;

    // Helper function to strip HTML and check for meaningful content
    const getPlainText = (text: string): string =>
      text?.replace(/<\/?[a-zA-Z][^>]*>/g, '')?.trim() || '';

    // For WhatsApp messages, check plain text content instead of raw HTML
    const hasContent = getPlainText(contentText)?.length;

    if (!hasContent) {
      return null;
    }

    return (
      <div className="task__content bs-mt-20">
        {currentData?.type === SequenceStepType.LinkedInInMail && (
          <div className="bs-mb-20">
            <span className="semibold-1 gray-txt-15">
              {`${getTaskContentLabel(currentData?.type)} Subject`}
            </span>
            <div className="task__content-area size-sm mt-1 d-flex align-items-center task-content-area-subject">
              <TruncatedTextWithAutoTooltip
                text={currentData?.taskPayload?.payload?.subject}
                className="cs-txt-ell"
              >
                <span className="regular-2 popover-arrow-color-txt">
                  {decodeHtmlEntities(
                    currentData?.taskPayload?.payload?.subject,
                  )}
                </span>
              </TruncatedTextWithAutoTooltip>

              <div className="task-copy-icon-static d-flex align-items-center justify-content-end">
                <OverlayTrigger
                  placement={Placement.Bottom}
                  overlay={getTooltip(!isSubjectCopied ? 'Copy' : 'Copied')}
                >
                  <div className="task-copy-icon-container">
                    {!isSubjectCopied ? (
                      <Copy
                        width={16}
                        height={16}
                        className="gray-txt-15 pointer"
                        onClick={() =>
                          onContentCopy(
                            currentData?.taskPayload?.payload?.subject,
                            true,
                          )
                        }
                      />
                    ) : (
                      <Check
                        width={16}
                        height={16}
                        className="gray-txt-15 pointer"
                      />
                    )}
                  </div>
                </OverlayTrigger>
              </div>
            </div>
          </div>
        )}

        <>
          <span className="semibold-1 gray-txt-15">
            {`${getTaskContentLabel(currentData?.type)} ${
              currentData?.type === SequenceStepType.WhatsAppVoiceCall
                ? 'Script'
                : 'Message'
            }`}
          </span>
          <div className="task__content-area mt-1 tasker-modal-content">
            <div className="task-content-scrollable">
              <span
                className="regular-2 popover-arrow-color-txt"
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                  __html: sanitizeRichText(contentText),
                }}
              />

              {/* Render Attachments */}
              {renderAttachments()}
            </div>

            <div className="task-copy-icon-static d-flex align-items-center justify-content-end">
              <OverlayTrigger
                placement={Placement.Bottom}
                overlay={getTooltip(!isContentCopied ? 'Copy' : 'Copied')}
              >
                <div className="task-copy-icon-container">
                  {!isContentCopied ? (
                    <Copy
                      width={16}
                      height={16}
                      className="gray-txt-15 pointer"
                      onClick={() => onContentCopy(contentText, false)}
                    />
                  ) : (
                    <Check
                      width={16}
                      height={16}
                      className="gray-txt-15 pointer"
                    />
                  )}
                </div>
              </OverlayTrigger>
            </div>
          </div>
        </>
      </div>
    );
  };
  const renderCallOutcomeSelect = () => (
    <div className="pl-4 pr-4">
      <span className="semibold-1 gray-txt-15">Call Task Outcome</span>
      <Select<{ key: string; label: string }>
        options={getCallOutcomeOptions}
        placeholder="Select call task outcome"
        selectedOptionKey={callOutcome?.key || currentData?.callOutcome}
        onChange={([option]) => handleOutcomeChange(option)}
        optionRenderer={(option) => <span>{option?.label}</span>}
        selectedOptionRenderer={([option]) => <span>{option?.label}</span>}
        placement={Placement.Bottom}
      />
    </div>
  );
  const getDateColumnCellValue = (tStatus: TaskStatusKey, date: string) => {
    if (tStatus === TaskStatusKey.DueToday) {
      return 'Due Today';
    }
    if (tStatus === TaskStatusKey.Upcoming) {
      return `Due in ${getFormattedDateWithMoment(date)}`;
    }
    if (tStatus === TaskStatusKey.Overdue) {
      return `Due ${getFormattedDateWithMoment(date)} ago`;
    }

    const formatted = getFormattedDateWithMoment(date);
    return formatted.toLowerCase() !== 'today' ? `${formatted} ago` : formatted;
  };

  return (
    <>
      <Modal
        show={show}
        aria-labelledby="contained-modal-title-vcenter"
        className="tasker-modal prospects-filters-modal"
        backdrop="static"
        enforceFocus={false}
      >
        <>
          <Modal.Header>
            <div className="d-flex justify-content-between align-items-center">
              <div className="d-flex align-items-center">
                {isLoading ? (
                  <SkeletonLoading width={40} height={40} className="rounded" />
                ) : (
                  renderTaskIcon()
                )}
                <div className="d-flex flex-column bs-ml-12">
                  <div className="d-flex align-items-center gap-8">
                    {isLoading ? (
                      <SkeletonLoading width={200} height={20} />
                    ) : (
                      <>
                        <TruncatedTextWithTooltip
                          length={isShareable ? 50 : 20}
                          string={removeLinkedinPrefix(
                            getSubjectStr(
                              currentData?.type,
                              currentData?.taskPayload?.payload?.title,
                            ),
                            currentData?.type,
                          )}
                          textClassName="semibold-2 popover-arrow-color-txt"
                        />
                        <OverlayTooltip
                          text={isLinkCopied ? 'Link Copied' : 'Copy Task Link'}
                          placement={Placement.Bottom}
                        >
                          <div
                            {...accessibleOnClick(() => {
                              navigator?.clipboard?.writeText(
                                window?.location?.href,
                              );
                              setIsLinkCopied(true);
                              setTimeout(() => setIsLinkCopied(false), 2000);
                            })}
                            className="link-task"
                          >
                            {isLinkCopied ? (
                              <Check width={14} height={14} />
                            ) : (
                              <LinkIcon width={14} height={14} />
                            )}
                          </div>
                        </OverlayTooltip>
                      </>
                    )}
                  </div>
                  <div className="mt-1 d-flex align-items-center">
                    {isLoading ? (
                      <SkeletonLoading
                        width={120}
                        height={16}
                        className="mr-2"
                      />
                    ) : (
                      <>
                        <span className="regular-1 font-medium gray-txt-15 mr-2">
                          {getDateColumnCellValue(
                            taskStatus,
                            currentData?.dueAt,
                          )}
                        </span>
                        {renderTaskPriority()}
                      </>
                    )}
                  </div>
                </div>
              </div>

              {!isLoading && <div className="">{renderTaskerPagination()}</div>}
            </div>
            <Button className="close" onClick={closeModal}>
              <Cross />
            </Button>
          </Modal.Header>
          <Modal.Body>
            {/* If LikedIn URL not Found */}
            {isLinkedInType(currentData?.type) &&
              !isLoading &&
              !getProspectDetails(currentData?.prospect?.attributes)
                ?.LinkedIn && (
                <div className="d-flex justify-content-center align-items-center url-banner">
                  <span className="semibold-1 line-height-18 red-txt-12 text-center">
                    LinkedIn URL is invalid / not available
                  </span>
                </div>
              )}

            {isWhatsappTask(currentData?.type) &&
              !isLoading &&
              !getProspectDetails(currentData?.prospect?.attributes)?.[
                'Phone Number'
              ] && (
                <div className="d-flex justify-content-center align-items-center url-banner">
                  <span className="semibold-1 line-height-18 red-txt-12 text-center">
                    WhatsApp number is not available
                  </span>
                </div>
              )}

            {/* Prospect Details Section */}
            <div className="mt-3">{renderProspectDetails()}</div>

            {/* Task Instruction */}

            {isLoading ? (
              <div className="task-note-loader size-sm mt-1 d-flex align-items-center justify-content-between">
                <SkeletonLoading width={432} height={150} />
              </div>
            ) : (
              (() => {
                const isLinkedInAutomation =
                  currentData?.type === SequenceStepType.AimfoxCampaignPush ||
                  currentData?.type === SequenceStepType.HeyReachCampaignPush;
                const instruction = currentData?.instruction;
                const hasInstruction =
                  !isLinkedInAutomation &&
                  instruction &&
                  instruction !== 'linkedin-automation' &&
                  instruction !== 'null';
                if (!hasInstruction) return null;
                return (
                  <div className="bs-mt-20 task-instruction-body-container">
                    {renderTaskInstruction()}
                  </div>
                );
              })()
            )}

            {/* Campaign Name for LinkedIn Automation tasks */}
            {!isLoading &&
              (currentData?.type === SequenceStepType.AimfoxCampaignPush ||
                currentData?.type ===
                  SequenceStepType.HeyReachCampaignPush) && (
                <div className="pl-4 pr-4 bs-mt-20 d-flex align-items-center">
                  <span className="semibold-1 gray-txt-15 mr-2">Campaign:</span>
                  <span className="regular-2 gray-txt-9">
                    {(currentData as any)?.taskPayload?.payload?.campaignName ||
                      (currentData as any)?.linkedInStepConfig?.campaignName ||
                      '—'}
                  </span>
                </div>
              )}

            {/* Task Content */}
            {!isLoading && renderTaskContent()}

            {/* Call Task Outcome */}
            {!isLoading &&
              isCallTask(currentData?.type) &&
              (taskStatus !== TaskStatusKey.Skipped ||
                (taskStatus === TaskStatusKey.Skipped &&
                  currentData?.callOutcome)) && (
                <div className="bs-mt-20">{renderCallOutcomeSelect()}</div>
              )}

            {/* Note Editor */}
            {!isLoading && (
              <div className="pl-4 pr-4 bs-mt-20">
                <span className="semibold-1 gray-txt-15 mb-1 d-block">
                  Note
                </span>
                <InlineMentionEditor
                  key={`task-editor-${currentData?.id}-${
                    noteResponse?.id || 'new'
                  }-${noteVisibility}`}
                  value={noteResponse?.content || taskEditorValue || ''}
                  onEditorChange={handleTaskEditorChange}
                  showAddAttachments={true}
                  showToolBarContainer={true}
                  showFooterToolbarContainer={true}
                  showFooterVisibilitySelector={true}
                  showFooterSaveButton={true}
                  onFooterSave={handleTaskNoteSave}
                  selectedVisibilityKey={noteVisibility}
                  onVisibilityChange={handleTaskVisibilityChange}
                  isFooterSaveButtonDisabled={
                    (!taskEditorValue?.trim() && !noteResponse?.content) ||
                    createProspectNoteRequestStatus === RequestStatus.Pending ||
                    updateProspectNoteRequestStatus === RequestStatus.Pending
                  }
                  mergeTags={MENTION_ARRAY}
                  placeholder={
                    noteVisibility === visibility.Private
                      ? 'Visible only to you and people tagged here'
                      : 'Visible to everyone in the organisation*'
                  }
                  saveButtonText={
                    hasNote || noteResponse ? 'Update Note' : 'Add Note'
                  }
                  attachments={noteAttachments}
                  onAttachmentsChange={handleTaskAttachmentsChange}
                  onAttachmentStatusChange={handleTaskAttachmentStatusChange}
                  sendAttachmentUploadRequest={sendUploadAttachmentRequest}
                  uploadAttachmentRequestStatus={uploadAttachmentRequestStatus}
                  uploadAttachmentRequestError={uploadAttachmentRequestError}
                  uploadedAttachment={uploadedAttachment}
                  resetUploadAttachmentRequest={resetUploadAttachmentRequest}
                  sendDeleteAttachmentRequest={sendDeleteAttachmentRequest}
                  deleteAttachmentRequestStatus={deleteAttachmentRequestStatus}
                  deleteAttachmentRequestError={deleteAttachmentRequestError}
                  deletedAttachmentId={deletedAttachmentId}
                  resetDeleteAttachmentRequest={resetDeleteAttachmentRequest}
                  onAttachmentsMetaChange={() => {}}
                />
              </div>
            )}
            {/* <CallLogsOutboundDetailSections row={callLogRow} /> */}

            {/* Call Insights (AI Summary / Call Logs / Notes) — only for call tasks */}
            {!isLoading &&
              isDialerAvailable &&
              isCallTask(currentData?.type) && (
                <TaskerCallInsights
                  aiSummaries={currentData?.aiSummary}
                  callLogs={currentData?.callLogs}
                  callNotes={currentData?.callNotes}
                  prospectId={currentData?.prospect?.id}
                />
              )}
          </Modal.Body>
          <Modal.Footer>
            {isLoading ? (
              <>
                <div className="d-flex align-items-center">
                  {/* Skip Button Skeleton */}
                  <div className="d-flex align-items-center">
                    <SkeletonLoading width={54} height={24} />
                  </div>
                </div>

                <div className="d-flex align-items-center">
                  <SkeletonLoading width={80} height={32} className="mr-3" />
                  <SkeletonLoading width={100} height={32} />
                </div>
              </>
            ) : taskStatus === TaskStatusKey.Failed ? (
              <div className="d-flex align-items-center justify-content-between w-100">
                <div
                  className="icon-container tasker-modal-skip pointer"
                  {...accessibleOnClick(() =>
                    handleUpdateTask(TaskAction.SkipTask),
                  )}
                >
                  <ForwardStep
                    width={16}
                    height={16}
                    className="gray-txt-15 mr-2"
                  />
                  <span className="regular-2 font-medium gray-txt-15 line-height-20">
                    Skip
                  </span>
                </div>
                <Button
                  variant="secondary"
                  onClick={() => handleUpdateTask(TaskAction.RetryLinkedInTask)}
                >
                  Retry
                </Button>
              </div>
            ) : (
              <>
                <div
                  className={`icon-container tasker-modal-skip ${
                    isTaskDisabled ? 'cursor-not-allowed opacity-30' : 'pointer'
                  }`}
                  {...(isTaskDisabled
                    ? {}
                    : accessibleOnClick(() =>
                        handleUpdateTask(TaskAction.SkipTask),
                      ))}
                >
                  <ForwardStep
                    width={16}
                    height={16}
                    className="gray-txt-15 mr-2"
                  />
                  <span className="regular-2 font-medium gray-txt-15 line-height-20">
                    Skip
                  </span>
                </div>

                <div className="d-flex align-items-center">
                  {currentData?.type !== SequenceStepType.AimfoxCampaignPush &&
                    currentData?.type !==
                      SequenceStepType.HeyReachCampaignPush && (
                      <>
                        <OverlayTooltip
                          text="Snooze"
                          placement={Placement.Top}
                          className="cell-card__tooltip"
                        >
                          <div
                            className={`icon-container tasker-modal-snooze ${
                              isTaskDisabled
                                ? 'cursor-not-allowed opacity-30'
                                : 'pointer'
                            }`}
                            {...(isTaskDisabled
                              ? {}
                              : accessibleOnClick(() =>
                                  handleUpdateTask(TaskAction.SnoozeTask),
                                ))}
                          >
                            <Alarm
                              width={16}
                              height={16}
                              className="gray-txt-15 pointer"
                            />
                          </div>
                        </OverlayTooltip>

                        <Button
                          variant="secondary"
                          className="ml-3"
                          onClick={() =>
                            handleUpdateTask(TaskAction.ExecuteTask)
                          }
                          disabled={isTaskDisabled}
                        >
                          <Check width={16} height={16} className="mr-2" />
                          Complete
                        </Button>
                        {isDialerAvailable &&
                          isCallTask(currentData?.type) &&
                          (isOngoingCall ? (
                            <OverlayTooltip
                              text="Another call is already in progress"
                              placement={Placement.Top}
                              className="cell-card__tooltip"
                            >
                              <Button
                                className="ml-3 tasker-modal-call-btn"
                                disabled
                              >
                                Call
                              </Button>
                            </OverlayTooltip>
                          ) : selectedPhoneNumber ? (
                            <Button
                              className="ml-3 tasker-modal-call-btn"
                              onClick={handleCallProspect}
                              disabled={myPhoneNumbersList?.total === 0}
                            >
                              Call
                            </Button>
                          ) : (
                            <OverlayTooltip
                              text="No phone number available. Please purchase or get one assigned to start calling."
                              placement={Placement.Top}
                              className="cell-card__tooltip"
                            >
                              <Button
                                className="ml-3 tasker-modal-call-btn"
                                disabled
                              >
                                Call
                              </Button>
                            </OverlayTooltip>
                          ))}
                        {/* <div className="prospect-drawer-header-footer-container-call-btn">
                        <Button
                          variant="primary"
                          className="prospect-drawer-header-footer-call-btn"
                          // {...accessibleOnClick(() => handleFooterCallBack())}
                          // disabled={!hasCallbackNumber}
                        >
                          <span>Call</span>
                        </Button>
                        <Button
                          variant="primary"
                          className="prospect-drawer-header-footer-call-icon"
                          // {...accessibleOnClick(() => handleFooterCallBack())}
                          // disabled={!hasCallbackNumber}
                        >
                          <ChevronDown width={16} height={16} />
                        </Button>
                      </div> */}
                      </>
                    )}

                  {isLinkedInType(currentData?.type) && (
                    <Button
                      className="ml-3"
                      onClick={sendLinkedinRequest}
                      disabled={
                        !getProspectDetails(currentData?.prospect?.attributes)
                          ?.LinkedIn
                      }
                    >
                      {getButtonLabel(currentData?.type)}
                    </Button>
                  )}

                  {renderWhatsAppButton()}

                  {(currentData?.type === SequenceStepType.AimfoxCampaignPush ||
                    currentData?.type ===
                      SequenceStepType.HeyReachCampaignPush) && (
                    <OverlayTooltip
                      text="Automation task can not be completed manually"
                      placement={Placement.Top}
                      className="cell-card__tooltip"
                    >
                      <span className="ml-3">
                        <Button variant="secondary" disabled>
                          <Check width={16} height={16} className="mr-2" />
                          Complete
                        </Button>
                      </span>
                    </OverlayTooltip>
                  )}
                </div>
              </>
            )}
          </Modal.Footer>
        </>
      </Modal>
      {showDncModal && (
        <AddToDncModal
          show={showDncModal}
          onClose={() => setShowDncModal(false)}
          phoneNumber={selectedPhoneNumber || ''}
          isSubmitting={addPhoneNumberRequestStatus === RequestStatus.Pending}
          onAddToDnc={(dncListId) => {
            if (!selectedPhoneNumber) return;
            sendAddPhoneNumberRequest({
              dncListId,
              phoneNumber: selectedPhoneNumber,
              updateOutcome: false,
            });
          }}
        />
      )}
    </>
  );
};

export default TaskerModal;
